(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  try {
      const dropdownMenus = document.querySelectorAll('.dropdown-menu');

          dropdownMenus.forEach((menu) => {
            const currentBg = window.getComputedStyle(document.body, null).getPropertyValue('background');

            if (currentBg.indexOf("rgb(122, 159, 245)") > -1) {
              menu.classList.add('blue');
              return;
            }

            if (currentBg.indexOf("rgb(246, 209, 113)") > -1) {
              menu.classList.add('yellow');
              return;
            }
            
          if (currentBg.indexOf("rgb(255, 112, 147)") > -1) {
            menu.classList.add('pink');
            return;
          }

          if (currentBg.indexOf("rgb(77, 106, 255)") > -1) {
            menu.classList.add('blue');
            return;
          }
      });

    } catch (error) {
    }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-template"]) return;
  try {
    

    var animationElement1 = document.getElementById('my-element').getAttribute('data-some-variable');
    var animation1 = bodymovin.loadAnimation({
      container: document.getElementById('animation'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: `${animationElement1}`
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-hjartegave"]) return;
  try {
    
   window.addEventListener("load", (event) => {

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
      e.preventDefault();

      document.querySelector(this.getAttribute('href')).scrollIntoView({
          behavior: 'smooth'
      });
  });
});
});
    window.addEventListener("load", (event) => {
      var animationElement1 = document.getElementById('my-element').getAttribute('data-some-variable');
      var animation1 = bodymovin.loadAnimation({
        container: document.getElementById('animation'),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: `${animationElement1}`
      });

      var animationElement2 = document.getElementById('my-element2').getAttribute('data-some-variable');
      var animation2 = bodymovin.loadAnimation({
        container: document.getElementById('animation2'),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: `${animationElement2}`
      });
    });
      
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-livstein"]) return;
  try {
    
    window.addEventListener("load", (event) => {

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
    });
});
  });
    window.addEventListener("load", (event) => {
      var animationElement1 = document.getElementById('my-element').getAttribute('data-some-variable');
      var animation1 = bodymovin.loadAnimation({
        container: document.getElementById('animation'),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: `${animationElement1}`
      });

      var animationElement2 = document.getElementById('my-element2').getAttribute('data-some-variable');
      var animation2 = bodymovin.loadAnimation({
        container: document.getElementById('animation2'),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: `${animationElement2}`
      });
    });
      
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-lysstein"]) return;
  try {
    
    window.addEventListener("load", (event) => {

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
    });
});
  });
    window.addEventListener("load", (event) => {
      var animationElement1 = document.getElementById('my-element').getAttribute('data-some-variable');
      var animation1 = bodymovin.loadAnimation({
        container: document.getElementById('animation'),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: `${animationElement1}`
      });

      var animationElement2 = document.getElementById('my-element2').getAttribute('data-some-variable');
      var animation2 = bodymovin.loadAnimation({
        container: document.getElementById('animation2'),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: `${animationElement2}`
      });
    });
      
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
      window.addEventListener("load", (event) => {

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
      e.preventDefault();

      document.querySelector(this.getAttribute('href')).scrollIntoView({
          behavior: 'smooth'
      });
  });
});
});
    window.addEventListener("load", (event) => {
      var animationElement1 = document.getElementById('my-element').getAttribute('data-some-variable');
      var animation1 = bodymovin.loadAnimation({
        container: document.getElementById('animation'),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: `${animationElement1}`
      });

      var animationElement2 = document.getElementById('my-element2').getAttribute('data-some-variable');
      var animation2 = bodymovin.loadAnimation({
        container: document.getElementById('animation2'),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: `${animationElement2}`
      });
    });
      
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-page-template"]) return;
  try {
    
              var animationElement = document.getElementById('my-element1').getAttribute('data-asset');
              var animation = bodymovin.loadAnimation({
                container: document.getElementById('animation1'),
                renderer: 'svg',
                loop: true,
                autoplay: true,
                path: `${animationElement}`
              });
              var dataAsset = document.getElementById('animation-element').getAttribute('data-asset');
              var animation = bodymovin.loadAnimation({
                container: document.getElementById('animation'),
                renderer: 'svg',
                loop: true,
                autoplay: true,
                path: `${dataAsset}`
              });

            
  } catch(e) { console.error(e); }
})();
})();
